import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  WifiPackagesStore,
} from 'mobx-store/stores/wifiPackagesStore';
import {
  Button,
} from '@material-ui/core';
import {
  IWifiPackageOption, IWifiPackage, ISelectedWifiPackage,
} from 'mobx-store/storeInterfaces/wifiPackageInterface';
import {
  cleanArray,
} from 'helperFunctions/cleanArray';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditWifiPackages.module.scss';
import {
  countriesIsoCodes,
} from '../../constants/countries';

interface IProps extends WithSnackbarProps {
  wifiPackagesStore: WifiPackagesStore;
  countryStore: CountryStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  loadingManagedCountries: boolean;
  processing: boolean;
  selectedLang: string;
  numberOfOptions: number;
}

@inject('wifiPackagesStore')
@inject('countryStore')
@observer
export class AddEditWifiPackage extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = false;

  wifiPackageId = -1;

  pageTitle = '';

  lastHistory = -1;

  wifiPackageFormTitle = '';

  wifiPackageSchema: any;

  submitButton: any;

  cancelButton: any;

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.wifiPackageId = props.match.params.id;
      this.pageTitle = translate('editWifiPackagePageTitle');
    } else {
      this.isNew = true;
      this.pageTitle = translate('addWifiPackagePageTitle');
    }
    this.initwifiPackageSchema(1);
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.wifiPackageFormTitle = translate('wifiPackagesPageTitle');
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  async componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.forceUpdate();
      await this.props.countryStore.getUserManagedCountries();
      if (this.props.countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
        this.isEgypt = true;
      }
      this.setState({
        loadingManagedCountries: false,
      });
      if (!this.isNew) {
        this.props.wifiPackagesStore.getWifiPackageById(this.wifiPackageId, languageCodes.english)
          .then(() => {
            this.updateStateWithWifiPackageData();
          }).catch(() => {
            this.setState({
              loading: false, selectedLang: languageCodes.english,
            });
          });
        this.dropdownLanguages = this.getDropdownLanguages();
      }
    }
  }

  handelLanguageChange = (langCode: string) => {
    if (this.isNew) {
      this.setState({
        selectedLang: langCode,
      });
    } else {
      this.getWifiPackage(langCode);
    }
  };

  initwifiPackageSchema = (numberOfOptions: number) => {
    const validationObject: any = {
    };
    for (let step = 1; step <= numberOfOptions; step++) {
      validationObject[`price ${step}`] = Yup.number().required('Required');
    }
    this.wifiPackageSchema = Yup.object().shape({
      name: Yup.string().max(100, 'Too Long!').required('Required'),
      description: Yup.string().max(255, 'Too Long!'),
      isActive: Yup.boolean().default(false),
      ...validationObject,
    });
  };

  getFormFields = (numberOfOptions: number):FormField[] => {
    const formFields: FormField[] = [
      {
        name: 'name',
        label: translate('name'),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'description',
        label: translate('description'),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'isActive',
        label: translate('Status'),
        filedType: 'ToggleButtonField',
        activeLabel: translate('FormActiveLabel'),
        inactiveLabel: translate('FormActiveLabel'),
        value: false,
      },
    ];

    for (let step = 1; step <= numberOfOptions; step++) {
      formFields.push(
        {
          name: `price ${step}`,
          label: `Price ${step}`,
          type: 'text',
          filedType: 'InputField',
        },
      );
    }

    return formFields;
  };

  addPackageOption = () => {
    const {
      numberOfOptions,
    } = this.state;
    const formFields = this.getFormFields(numberOfOptions + 1);
    this.setState({
      formFields,
      numberOfOptions: numberOfOptions + 1,
    });
  };

  initState = (isConstructor = true) => {
    const initState: IState = {
      selectedLang: this.isNew ? languageCodes.arabic : languageCodes.english,
      processing: false,
      loadingManagedCountries: true,
      loading: !this.isNew,
      formFields: this.getFormFields(1),
      numberOfOptions: 1,
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  navigateBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (values: any): void => {
    const {
      countryStore,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);

    this.setState({
      processing: true,
    });

    if (this.isNew) {
      const structuredValues = this.restructureFormDataToStore(values, false);
      try {
        this.props.wifiPackagesStore.createWifiPackage(structuredValues)
          .then((wifiPackageId) => {
            if (this.isEgypt) {
              this.props.history.push(`${wifiPackageId}/edit`);
            } else {
              this.props.history.go(this.lastHistory);
            }
          });
      } catch {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage'), 5000, 'error');
      }
    } else {
      const structuredValues = this.restructureFormDataToStore(values, true);

      this.props.wifiPackagesStore.updateWifiPackage(structuredValues, this.wifiPackageId, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage'), 5000, 'success');
          this.props.history.go(this.lastHistory);
        }).catch(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage'), 5000, 'error');
        });
    }
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.navigateBack,
  });

  updateStateWithWifiPackageData = () => {
    const {
      wifiPackagesStore: {
        selectedWifiPackage,
      },
    } = this.props;
    const {
      wifiPackageOption = [],
    } = selectedWifiPackage;
    const optionsLength = wifiPackageOption.length;
    const formFields = this.getFormFields(optionsLength);
    this.setState({
      formFields,
      numberOfOptions: optionsLength,
    });

    const formFieldsWithData = [];

    const formData = this.restructureDataFromStore(selectedWifiPackage);

    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field,
        value: formData[field.name],
      });
    }
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  getFormPageHeader = () => (
    <div className={classes.header}>
      <IconButton
        className={classes.backButton}
        onClick={() => this.props.history.goBack()}
        aria-label="Back"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <Typography className={classes.title} variant="h6" gutterBottom>
        {this.pageTitle}
      </Typography>
    </div>
  );

  render() {
    return (
      <div className={classes.container}>
        {this.getFormPageHeader()}
        <div className={classes.content}>
          {this.state.loading || this.state.loadingManagedCountries
            ? <Spinner />
            : (
              <GeneralFormComponent
                dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                formTitle={`${this.wifiPackageFormTitle} ${this.state.selectedLang.toUpperCase()}`}
                fields={this.state.formFields}
                formSchema={this.wifiPackageSchema}
                submitButton={this.submitButton}
                cancelButton={this.cancelButton}
                processing={this.state.processing}
              />
            )}
        </div>
        <div>
        </div>
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore, wifiPackagesStore,
    } = this.props;
    await countryStore.getUserManagedCountries();
    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }

    this.initState(false);
    this.submitButton = this.getSubmitButton();

    this.setState({
      loadingManagedCountries: false,
    });

    if (!this.isNew) {
      wifiPackagesStore.getWifiPackageById(this.wifiPackageId, this.state.selectedLang)
        .then(() => {
          this.updateStateWithWifiPackageData();
        }).catch(() => {
          this.setState({
            loading: false,
          });
        });
    }
  }

  getWifiPackage = (langCode: string) => {
    const {
      countryStore, wifiPackagesStore,
    } = this.props;
    this.setState({
      loading: true,
    });
    wifiPackagesStore.getWifiPackageById(this.wifiPackageId, langCode)
      .then(() => {
        this.updateStateWithWifiPackageData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
  };

  restructureDataFromStore(formData: ISelectedWifiPackage) {
    const formObject: any = {
    };

    formObject.name = formData.name;
    formObject.description = formData.description;
    formObject.isActive = formData.isActive;

    let optionNumber = 1;

    formData.wifiPackageOption.map((packageOption, index) => {
      formObject[`price ${optionNumber}`] = packageOption.price;

      optionNumber += 1;
    });

    return formObject;
  }

  restructureFormDataToStore = (formValues: any, updating = true) => {
    const {
      numberOfOptions,
    } = this.state;
    const {
      wifiPackagesStore,
    } = this.props;
    let packageOptions: IWifiPackageOption[] = [];
    for (let step = 1; step <= numberOfOptions; step++) {
      const packageOption: IWifiPackageOption = {
        price: formValues[`price ${step}`],
      };
      const currentPackageOption = wifiPackagesStore.selectedWifiPackage.wifiPackageOption[step - 1];
      if (updating && currentPackageOption) {
        const {
          packageOptionId,
        } = currentPackageOption;
        packageOption.packageOptionId = packageOptionId;
      }

      packageOptions.push(packageOption);
    }

    packageOptions = cleanArray(packageOptions);

    const form: IWifiPackage = {
      name: formValues.name,
      description: formValues.description,
      isActive: formValues.isActive,
      availableCountries: formValues.availableCountries,
      packageOptions,
    };

    return form;
  };
}

export default withRouter(AddEditWifiPackage);
